// extracted by mini-css-extract-plugin
module.exports = {"container":"Root_container__FbYRt"};